import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Technology from "@/pages/Technology";
import ProductDetail from "@/pages/ProductDetail";
import Labs from "@/pages/Labs";
import Founder from "@/pages/Founder";
import Mission from "@/pages/Mission";
import Newsroom from "@/pages/Newsroom";
import Article from "@/pages/Article";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import PoweredBy from "@/pages/PoweredBy";
import UniversePage from "@/pages/UniversePage";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ContentProvider>
            <Toaster theme="dark" position="bottom-right" richColors />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/technology" element={<Technology />} />
                <Route path="/companies" element={<Technology />} />
                <Route path="/technology/:slug" element={<ProductDetail />} />
                <Route path="/labs" element={<Labs />} />
                <Route path="/founder" element={<Founder />} />
                <Route path="/mission" element={<Mission />} />
                <Route path="/newsroom" element={<Newsroom />} />
                <Route path="/newsroom/:slug" element={<Article />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/powered-by" element={<PoweredBy />} />
                <Route path="/universe" element={<UniversePage />} />
                <Route path="/legal/:doc" element={<Legal />} />
              </Route>
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
